import toast from "react-hot-toast";
import { useRouterQueryParam } from "@common/hooks";
import { useEffect } from "react";

const useDocusignToastMessages = () => {
  const { queryParam: eventParam, removeQueryParam: removeEventParam } =
    useRouterQueryParam("event");
  const { queryParam, removeQueryParam } = useRouterQueryParam("state");
  useEffect(() => {
    if (queryParam === "docusign_coclient_signature_required") {
      toast(
        "We've sent an email with a DocuSign to your co-client for signature. Please mark the task as completed once they've signed it.",
        {
          id: "docusign_coclient_signature_required",
          position: "top-right",
          icon: "   📨",
          duration: 15000,
        }
      );
      removeQueryParam();
    } else if (queryParam === "docusign_coclient_signature_task_required") {
      toast(
        "Welcome back from DocuSign. Please mark your task as completed to enable your co-client to sign the agreement from the task with their name.",
        {
          id: "docusign_coclient_signature_task_required",
          position: "top-right",
          icon: "   ✅",
          duration: 15000,
        }
      );
      removeQueryParam();
    } else if (
      eventParam === "viewing_complete" ||
      eventParam?.includes("viewing_complete") ||
      eventParam === "signing_complete" ||
      eventParam?.includes("signing_complete")
    ) {
      toast(
        "Welcome back from DocuSign. If you signed the agreement, you can now mark the task as completed.",
        {
          id: "docusign_viewing_complete",
          position: "top-right",
          icon: "🎉",
          duration: 15000,
        }
      );
      removeEventParam();
    }
  }, [queryParam, eventParam, removeEventParam, removeQueryParam]);
};

export { useDocusignToastMessages };
